import React from 'react';


const Videos = () => {
  return (
    <div class="container">
      <br></br>
      <h5 class="rowcards">Indicaciones generales</h5>
      <br></br>
      <div class="row">
        <div class="col-sm">
          <div class="accordion" id="accordionExample">

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button class="accordion-button videos collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseReq" aria-expanded="false" aria-controls="collapseReq">
                 <strong>1&nbsp;&nbsp;</strong>Requisitos
                </button>
              </h2>
              <div id="collapseReq" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <ul>
                    <li>Instalar la última versión del aplicativo de evaluaciones en el dispositivo que te vas a evaluar (Computador de escritorio, portátil o tableta que cuente con cámara web y micrófono en óptimas condiciones). Es importante que consideres que no está autorizado evaluarse con teléfono celular. </li>
                    <li>Contar con una conexión estable a internet (mínimo de 1 Mbps) para rendir la evaluación. Se recomienda no tener conectados otros dispositivos durante el proceso, para asegurar la calidad de la señal y no tengas inconvenientes.</li>
                    <li>Ingresar con 15 minutos antes de la hora asignada.</li>
                    <li>Es obligatoria la presentación del documento de identidad original (cédula o pasaporte).</li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
        <br />
        <div class="col-sm">
          <div class="accordion" id="accordionExample">

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button class="accordion-button videos collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                <strong>2&nbsp;&nbsp;</strong>Instalación del aplicativo
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                <iframe title="vale" width="500" height="400" src="https://www.youtube.com/embed/2yK_BV1Gg7c" frameborder="0"></iframe>                </div>
              </div>
            </div>

          </div>
        </div>
        <br />
        <div class="col-sm">
          <div class="accordion" id="accordionExample">

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <button class="accordion-button videos collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                <strong>3&nbsp;&nbsp;</strong> Cómo realizar tu evaluación
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                <iframe title="vale" width="500" height="400" src="https://www.youtube.com/embed/VTaTTtTD9Jw" frameborder="0"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="accordion" id="accordionExample">

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingFor">
                <button class="accordion-button videos collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFor" aria-expanded="false" aria-controls="collapseThree">
                <strong>4&nbsp;&nbsp;</strong> Consulta de horarios
                </button>
              </h2>
              <div id="collapseFor" class="accordion-collapse collapse" aria-labelledby="headingFor" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                Para conocer el día y la hora en que debes rendir tus evaluaciones ingresa aquí <br>
                
                
                </br><a href="https://consultahorarios.utpl.edu.ec/" class="btn btn-warning">Horarios</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>





  );
}


export default Videos;